export default {
  loading: 'লোড হচ্ছে...',
  'no-update': 'সর্বশেষ সংস্করণ',
  'load-more': 'আরও লোড করুন',
  'copy-success': 'সফলভাবে কপি করা হয়েছে',
  'invalid-url': 'ভুল URL',
  dicePopular: 'সবচেয়ে জনপ্রিয় ডাইস খেলা',
  indianLottery: 'ভারতীয় আদালতী লটারি',
  jackpot: 'জ্যাকপট',
  home: {
    tab: {
      home: 'হোম',
      result: 'ফলাফল',
      casino: 'ক্যাসিনো',
      scratch: 'আঁচড়',
      scratchOff: 'আঁচড়ে ফেলা',
      referral: 'প্রতিনিধি',
      me: 'আমি',
      live: 'লাইভ',
      liveCasino: 'লাইভ ক্যাসিনো',
      sports: 'খেলাধুলা',
      lottery: 'লটারি',
      promotions: 'প্রচার',
      invite: 'আমন্ত্রণ জানান',
      wallet: 'মানিব্যাগ',
      proxyhome: 'এজেন্সি',
      chat: 'চ্যাট',
    },
    scratch: {
      title: 'আঁচড়',
      free: 'ফ্রি',
    },
    kerala: {
      title: 'কেরলা স্টেট লটারি',
      no: 'নং।',
      lastResult: 'শেষ জ্যাকপট ফলাফল',
    },
    digit: {
      title: '3 ডিজিট খেলা',
      booking: 'পরবর্তী বুকিং জন্য সময়',
      ticket: 'টিকেট',
      price: 'টিকেট দাম',
      lastResult: 'শেষ টিকেট ফলাফল',
      drawTime: 'পরবর্তী টিকেট সময়',
    },
    dice: {
      title: 'ডাইস খেলা',
      play: 'এখন খেলুন',
    },
    color: {
      title: 'রঙের পূর্বাভাস',
    },
    matka: {
      bid: 'বিড',
      win: 'জয়',
      OPEN: 'খোলা',
      CLOSE: 'বন্ধ',
      open: 'খোলা',
      close: 'বন্ধ',
      title: 'সাট্টা মাটকা',
    },
    'live-casino': {
      title: 'লাইভ ক্যাসিনো',
    },
    car: {
      title: 'দ্রুত দৌড়',
      min: 'মিনিট',
      text: 'পরবর্তী টিকেট শুরু হয়েছে',
    },
    tip: {
      closed: '{{name}} এখন বন্ধ আছে, অনুগ্রহ করে পরবর্তী খেলা বাছনা করুন।',
      copied: 'কপি সফলভাবে করা হয়েছে, অনুগ্রহ করে বন্ধুদের সাথে শেয়ার করুন।',
    },
    label: {
      menu: 'মেনু',
      viewAll: 'সব দেখুন',
      buyNow: 'এখন কিনুন',
      'lucky-spin': 'লাকি স্পিন',
      rebate: 'ছাড়',
      'free-lottery': 'ফ্রি লটারি',
      referral: 'প্রতিনিধি',
      'refer-friend': 'প্রতিনিধি জানান',
      agent: 'Agent',
      biggestWins: 'বিগস্ট জয়',
      jackpotGames: 'জ্যাকপট খেলা',
      onlineUser: '{{number}} ব্যবহারকারী খেলছে',
      popularGame: 'সবচেয়ে জনপ্রিয় খেলা',
      provedores: 'প্রদানকারী',
      allGames: 'সব খেলা',
      more: 'আরও',
      games: 'খেলা',
      days: 'দিন',
      hours: 'ঘন্টা',
      minutes: 'মিনিট',
      seconds: 'সেকেন্ড',
      total: 'মোট',
      bet: 'বেট',
      online: 'অনলাইন',
      winningAmount: 'জয়ক্ষতি পরিমাণ',
      imgFail: 'ছবি লোড হয়নি',
      partners: 'বিশ্বস্ত স্পনসর এবং অংশীদারদের',
      pays: 'উপলব্ধ পেমেন্ট পদ্ধতি',
      social: 'সামাজিক যোগাযোগ',
      licenses: 'লাইসেন্স',
      promotions: 'প্রচার',
      invite: 'আমন্ত্রণ জানান',
      agency: 'সংস্থা',
      luckySpin: 'লাকি স্পিন',
      chat: 'সেবা',
      all: 'সব',
      availOutcomes: '{{count}} প্রদত্ত ফলাফল',
      downText: 'ডেস্কটপে যোগ করুন',
      experience: 'নতুন অভিজ্ঞতা দাও',
      adventure: 'নতুন গেমিং অ্যাডভেঞ্চারের অভিজ্ঞতা অর্জন করুন',
      earn: 'টাকা উপার্জন করুন',
    },
    luckyspin: {
      add: 'যোগ করুন',
      spin: 'স্পিন',
      won: 'জয়',
      winner: 'বিগস্ট জয়',
      mySpin: 'আমার স্পিন',
    },
    title: {
      scratchOff: 'আঁচড়ে ফেলা',
      casino: 'ক্যাসিনো',
      live: 'লাইভ',
      sports: 'খেলাধুলা',
      lottery: 'লটারি',
      scratch: 'আঁচড়ে ফেলা',
      servertime: 'সার্ভার উপযোগিতা দিন',
      winningInformation: 'বিজয়ী তথ্য',
      todayEarningsChart: 'আজকের আয় চার্ট',
    },
  },
  casino: {
    sortby: 'সাজানোর ভিত্তিতে',
    categories: 'বিভাগ',
    popular: 'জনপ্রিয়',
    all: 'সব',
    lobby: 'লবি',
    tabs: {
      lobby: 'লবি',
      'new games': 'নতুন খেলা',
      'table games': 'টেবিল খেলা',
      slots: 'স্লট',
      'fishing games': 'মাছ ধরা খেলা',
      rummy: 'রুমি',
      others: 'অন্যান্য',
    },
  },
  me: {
    label: {
      rechargeRecord: 'রিচার্জ প্রতিবেদন',
      withdrawRecord: 'প্রত্যাহার প্রতিবেদন',
      check: 'পরীক্ষা করুন',
    },
    webview: {
      vip: 'সদস্য কেন্দ্র',
    },
    new: 'নতুন',
    user: {
      userId: 'ব্যবহারকারী আইডি',
      moreExciting: 'লগইন করার পরে আরও উত্তেজনাপূর্ণ',
      login: 'লগইন করুন',
      loginUpper: 'লগইন করুন',
      uid: 'ইউআইডি:',
      lastLogin: 'শেষ লগইন:',
      bindPhone: 'বাইন্ডিং',
      confirm: 'নিশ্চিত',
      skip: 'স্কিপ',
      bindSuccess: 'বিবদ্ধিত!',
      bindSuccessContent: '10s স্বয়ংক্রিয়ভাবে হোম পৃষ্ঠায় যাবে',
    },
    money: {
      totalWallet: 'মোট মানিব্যাগ',
      myWallet: 'আমার মানিব্যাগ',
      cashBalance: 'ক্যাশ ভারসাম্য',
      withdrawAmount: 'প্রত্যাহারযোগ্য পরিমাণ',
      totalBalance: 'মোট ভারসাম্য',
      wallet: 'মানিব্যাগ',
      recharge: 'রিচার্জ',
      withdraw: 'প্রত্যাহার করুন',
    },
    vip: {
      recharge: 'রিচার্জ',
      move: 'স্তরে পৌঁছাতে আরও অনেক কিছু',
      moveVip: '{{level}} স্তরে পৌঁছাতে আরও <0>{{amount}}</0> রিচার্জ করুন।',
    },
    bottom: {
      recharge: 'রিচার্জ',
      withdraw: 'প্রত্যাহার করুন',
      transfer: 'স্থানান্তর',
      proxy: 'এজেন্সি সেন্টার',
      logout: 'লগ আউট',
      resultHistory: 'ফলাফলের ইতিহাস',
      myBets: 'আমার বাজি',
      myTransactions: 'আমার লেনদেন',
      commission: 'আমার কমিশন',
      notify: 'বিজ্ঞপ্তি',
      lang: 'ভাষা',
      customer: 'গ্রাহক সেবা',
      update: 'আপডেট',
      password: 'পাসওয়ার্ড',
    },
    language: {
      switch: 'ভাষা পরিবর্তন করুন',
      english: 'ইংরেজি',
    },
    tip: {
      cashTitle: 'নগদ ব্যালেন্স:',
      cashContent:
        '"নগদ ব্যালেন্স" বলতে আপনার অ্যাকাউন্টে উপলব্ধ প্রকৃত নগদ তহবিলকে বোঝায় যা বাজি বা অন্যান্য লেনদেনের জন্য ব্যবহার করা যেতে পারে।',
      withdrawTitle: 'প্রত্যাহারযোগ্য পরিমাণ:',
      withdrawContent:
        '"প্রত্যাহারযোগ্য পরিমাণ" হল আপনার নগদ ব্যালেন্সের সেই অংশ যা আপনার অ্যাকাউন্ট থেকে প্রত্যাহার করা যেতে পারে। এটি সেই অর্থকে প্রতিনিধিত্ব করে যা বাজির প্রয়োজনীয়তা পূরণ করেছে, যেগুলি তহবিল প্রত্যাহার করার আগে পূরণ করতে হবে।',
      dailyRewards: 'উত্তেজনাপূর্ণ পুরষ্কার অপেক্ষা করছে, এখনই পদক্ষেপ নিন!',
      bonus: '<0>ফ্রি</0> পুরষ্কার জিতুন, এখনই আপনার পুরষ্কার দাবি করুন!',
      anyquery: 'যেকোনো প্রশ্ন এবং অভিযোগের জন্য আমাদের এ ইমেল করুন।',
    },
    profile: {
      myProfile: 'আমার প্রোফাইল',
      bind_phone: 'ফোন বাইন্ড করুন',
      phone_number: 'ফোন নম্বর',
      enter_phone: 'আপনার ফোন নম্বর লিখুন',
      verification_code: 'প্রতিবেদন কোড',
      enter_code: 'প্রতিবেদন কোড লিখুন',
      bind: 'বাইন্ড',
      changePassword: 'পাসওয়ার্ড পরিবর্তন করুন',
    },
  },
  invitation: {
    title: {
      singUp: 'ফ্রি লটারি টিকেট',
    },
    label: {
      claim: 'আপনার টিকেট পান',
    },
  },
  push: {
    mainText: 'এই ওয়েবসাইটটি আপনার জন্য সুন্দর আপডেট এবং অফার পাঠাতে চায়!',
    secText: 'ব্রাউজার সেটিংসের মাধ্যমে সত্যিই কোনো সময়ই বন্ধ করা যায়।',
    allow: 'অনুমোদন করুন',
    block: 'অনুমোদন না করুন',
  },
  promotionsV2: {
    bonus: 'বোনাস',
    reward: 'পুরষ্কার',
    promotion: 'প্রচার',
    history: 'ইতিহাস',
    climb: 'উপরে যান',
    receive: 'প্রাপ্ত',
    received: 'প্রাপ্ত',
    expired: 'শেষ হয়েছে',
    joined: '{{num}} জয়ের জন্য যোগদান করুন',
    join: 'যোগ দিন এবং জিতুন',
    claimTime: 'প্রতিবেদন সময়',
    depositAmount: 'জমা পরিমাণ',
    bonusAmount: 'বোনাসের পরিমাণ',
    status: 'স্থিতি',
    congratulations: 'বিবদ্ধিত!',
    getBonus: 'বোনাস পান',
    claimNow: 'বর্তমানে প্রতিবেদন করুন',
    taskList: 'কার্য তালিকা',
    remainTime: 'বাকি সময়',
    joinNow: 'বর্তমানে যোগদান করুন',
    rules: 'ইভেন্টের নিয়মাবলী',
    vipLevel: 'VIP স্তর',
    rechargeAmount: 'রিচার্জের পরিমাণ',
    withdrawAmount: 'প্রত্যাহারের পরিমাণ',
    rechargeBonus: 'রিচার্জ বোনাস',
    details: 'ইভেন্টের বিবরণ',
    activityTime: 'কার্যকলাপের সময়',
    yourCurrentRecharge: 'আপনার বর্তমান রিচার্জ',
    eventRewards: 'ইভেন্ট পুরষ্কার',
    cumuBets: 'ক্রমবর্ধমান বাজি',
    rechargeCount: 'রিচার্জের সংখ্যা',
    withdrawCount: 'প্রত্যাহারের সংখ্যা',
    prize: {
      ticket: 'কেরলা লটারি',
      spin: 'লাকি স্পিন',
    },
    type: {
      recharge: 'রিচার্জ',
      withdraw: 'প্রত্যাহার করুন',
      bet: 'বেট',
    },
    times: {
      1: '1st',
      2: '2nd',
      3: '3rd',
      4: '4th',
    },
    tip: {
      claim: 'বেট <0>{{amount}}</0> বাকি প্রত্যাহার করুন বোনাস পান',
      required: '<0>{{multiple}}</0> বাজি প্রয়োজন',
      expired: 'ইভেন্ট শেষ হয়েছে',
      withdraw: 'উত্তোলন সময়ের জন্য প্রত্যাহার করুন',
      delete: 'আপনি কি নিশ্চিত যে আপনি এই বোনাসটি মুছে দিতে চান?',
      deleteSuccess: 'সফলভাবে মুছে দেওয়া হয়েছে',
      toReceive:
        '{{type}} <0>{{rechargeAmount}}</0> রিচার্জ করলেই পাবেন <0>{{bonusAmount}}</0> বোনাস',
      timeToReceive:
        '{{type}} <0>{{rechargeAmount}}</0> বার রিচার্জ করলেই পাবেন <0>{{bonusAmount}}</0> বোনাস',
      completedRecharge: 'আপনি আপনার {{times}} রিচার্জ সম্পন্ন করেছেন',
      notCompleteRechargeTitle: '{{times}} রিচার্জ',
      currentRechargeTitle: 'আপনার {{times}} রিচার্জ',
      rechargeToGet: 'রিচার্জ {{amountRange}} প্রাপ্ত হয়েছে {{bonus}} বোনাস',
      mustComplete:
        'আপনার আপনার {{currentCount}} রিচার্জ সম্পন্ন করতে হবে {{nextCount}} রিচার্জ ইভেন্টে যোগদান করতে',
      notLogin: 'এই ইভেন্টে যোগদান করতে প্রথমে লগইন করুন',
    },
    backend: {
      activityType: {
        RECHARGE: 'রিচার্জ',
        WITHDRAW: 'প্রত্যাহার করুন',
        RECHARGE_CUMULATE_COUNT: 'রিচার্জ ক্রমবর্ধমান সংখ্যা',
        PURCHASE_CUMULATE_AMOUNT: 'ক্রয় ক্রমবর্ধমান পরিমাণ',
        WITHDRAW_CUMULATE_COUNT: 'প্রত্যাহারের ক্রমবর্ধমান সংখ্যা',
        WITHDRAW_CUMULATE_AMOUNT: 'প্রত্যাহারের ক্রমবর্ধমান পরিমাণ',
        RECHARGE_CUMULATE_AMOUNT: 'রিচার্জ ক্রমবর্ধমান পরিমাণ',
        PROMOTION: 'প্রচার',
      },
    },
  },
  login: {
    failed: {
      title: 'লগইন ব্যর্থ',
      message: 'লগইন ব্যর্থ, অনুগ্রহ করে পরবর্তীতে চেষ্টা করুন',
    },
  },
  privacy: {
    confirmation:
      'এই বোতামটি ক্লিক করে আপনি নিশ্চিত করছেন যে আপনি কোম্পানির <terms>টার্মস এবং কন্ডিশনস</terms> এবং <policy>প্রাইভেসি পলিসি</policy> পড়েছেন এবং তাতে সম্মত হচ্ছেন এবং নিশ্চিত করছেন যে আপনার বৈধ বয়স',
    terms: 'টার্মস এবং কন্ডিশনস',
    policy: 'প্রাইভেসি পলিসি',
  },
  result: {
    lottery: {
      scratch: 'আঁচড়ে ফেলা',
      kerala: 'কেরলা',
      digit: '3 ডিজিট',
      quickDigit: 'দ্রুত 3 ডিজিট',
      color: 'রং',
      dice: 'ডাইস',
      matka: 'মাটকা',
      racecar: 'দ্রুত রেস',
      stateLottery: 'রাস্তা লটারি',
    },
    leaderboard: {
      today: 'আজকের লেডারবোর্ড',
    },
    tableHeader: {
      scratchOff: 'আঁচড়ে ফেলা',
      user: 'ব্যবহারকারী',
      bonus: 'বোনাস',
      game: 'খেলা',
    },
    label: {
      viewAll: 'সব দেখুন',
    },
    tip: {
      congratulations: 'বিবদ্ধিত!',
      youHaveWon: 'আপনি জয়ীন হন',
      sorry: 'দুঃখিত!',
      betterLuck: 'পরবর্তী লটারির জন্য বোনাস অনুভব করুন',
    },
  },
  transactions: {
    tabs: {
      all: 'সব',
      winnings: 'বিজয়ী',
      recharge: 'রিচার্জ',
      bets: 'বেট',
      withdraw: 'প্রত্যাহার করুন',
      commission: 'কমিশন',
      rebate: 'রিবেট',
      vip: 'VIP',
      transfer: 'স্থানান্তর',
      invitation: 'প্রতিবেদন',
      bonus: 'পুরষ্কার',
    },
  },
};
